import { useCallback } from "react";

import { useMutation, graphql } from "react-relay";
import { useTodoEditSetTagsMutation } from "./__generated__/useTodoEditSetTagsMutation.graphql";

export function useTodoEditSetTags(
  id: string,
  currentEmployeeId: string | null
) {
  const [updateTags, loading] = useMutation<useTodoEditSetTagsMutation>(graphql`
    mutation useTodoEditSetTagsMutation(
      $id: ID!
      $tagIds: [ID!]!
      $employeeId: ID
    ) @raw_response_type {
      todo(todoId: $id, employeeId: $employeeId) {
        updateTags(input: { tagIds: $tagIds }) {
          todo {
            id
            tags {
              id
            }
          }
        }
      }
    }
  `);

  const saveTags = useCallback(
    (tagIds: string[]) => {
      return updateTags({
        variables: {
          id,
          tagIds,
          employeeId: currentEmployeeId,
        },
        optimisticResponse: {
          todo: {
            updateTags: {
              todo: { id, tags: tagIds.map((id) => ({ id })) },
            },
          },
        },
      });
    },
    [currentEmployeeId, id, updateTags]
  );

  return [saveTags, loading] as const;
}
